/**
 * @fileoverview POST handler for the "/internal_user_groups/delete_internal_user_groups" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsInternalUserGroupsDeleteInternalUserGroupsCacheKeys } from "./constants";
import type {
  AppSettingsInternalUserGroupsDeleteInternalUserGroupsArguments,
  AppSettingsInternalUserGroupsDeleteInternalUserGroupsResult,
} from "./types";

export const postAppSettingsInternalUserGroupsDeleteInternalUserGroups = reactQueryMutationAdapter(
  appSettingsInternalUserGroupsDeleteInternalUserGroupsCacheKeys,
  ({
    appGroupId,
    internalUserGroupIds,
  }: AppSettingsInternalUserGroupsDeleteInternalUserGroupsArguments): Promise<AppSettingsInternalUserGroupsDeleteInternalUserGroupsResult> => {
    return fetch("/internal_user_groups/delete_internal_user_groups", "POST", {
      internal_user_group_ids: internalUserGroupIds,
      app_group_id: appGroupId,
    });
  }
);
